



















































// vue
import Vue from 'vue';

import * as models from '@/class/models/views/setting/users';
import * as workstyleModels from '@/class/models/views/setting/workstyle';

// api
import API from '@/api/common';

import SideBarBase from '@/components/util/SideBarBase.vue';

import { CalEvent } from '@/class/models/views/labor';
import { ICustomHolidayView } from '@/class/models/typed/custom-holiday';

import LaborDayTimeline from '@/parts/labor/LaborDayTimeline.vue';

import { formatYmd, formatYm } from '@/class/common/util/date_util';

import { ILaborCalendarEvent } from '@/class/models/typed/labor';

import LogResultPanel from '@/parts/labor/LogResultPanel.vue';
import ListDetailV3 from '@/components/util/ListDetailV3.vue';
import * as graphModels from '@/class/models/views/graph';

import { IWorkCategoryUser } from '@/class/models/typed/work-category';

import { parseYmd } from '@/class/common/util/date_util';

import { mapLaborEventToTimeline } from '@/util/labor-timeline';
import { routerPush } from '@/util/vue-router-util';

// util
import { GetUsingDepartmentsList, loadValidSideBarInfo, saveSideBarInfo, SideBarInfo } from '@/util/labor-management-util';

interface IOption {
  id: number;
  value: number;
  text: string;
}
interface TimelineEvent {
  id: string | number;
  start: string;
  end: string;
  kind: 'work' | 'absence';
  absenceType?: string;
  isAllDay?: boolean;
  title?: string;
  note?: string;
  description?: string;
}

function toTimelineEventFromCustomHoliday(holiday: ICustomHolidayView): TimelineEvent {
  return {
    id: `custom-holiday-${holiday.customHolidayID}`,
    start: '09:00',
    end: '18:00',
    kind: 'absence',
    absenceType: holiday.name,
    isAllDay: true,
  };
}

async function fetchDailyLaborEvents(userId: number, date: Date): Promise<ILaborCalendarEvent[]> {
  const start = formatYmd(date);
  const end = new Date(date);
  end.setDate(date.getDate() + 1);

  const res = await api.get<ILaborCalendarEvent[]>('labor/daily_reports', {
    userId,
    periodStart: start,
    periodEndExclusive: formatYmd(end),
  });

  return Array.isArray(res.data) ? res.data : [];
}

function resolveBaseDate(queryDate: unknown): { baseDate: Date; shouldReplace: boolean } {
  if (typeof queryDate === 'string') {
    const parsed = parseYmd(queryDate);
    if (parsed) {
      return { baseDate: parsed, shouldReplace: false };
    }
  }
  return { baseDate: new Date(), shouldReplace: true };
}

async function fetchCustomHolidayEvents(targetDate: string): Promise<TimelineEvent[]> {
  const res = await api.get<workstyleModels.VCustomHolidayList>('workstyle/customholiday');

  return Array.isArray(res.data.customHolidays)
    ? res.data.customHolidays.filter(h => h.date === targetDate).map(toTimelineEventFromCustomHoliday)
    : [];
}

const api = new API();

export default Vue.extend({
  name: 'LaborManagementDaily',
  components: { SideBarBase, LaborDayTimeline, LogResultPanel, ListDetailV3 },
  data() {
    return {
      departments: [] as models.IDepartmentInfo[],
      usersList: [] as models.IUser[], // 全従業員の詳細情報
      isDefault: false, // SP初期表示時はdefault:true
      selectedDepartmentID: -1,
      selectedUserID: -1,
      selectDepartment: {} as models.IDepartmentInfo,
      selectUser: {} as models.IUser,
      selectCalenderDate: undefined as Date,
      date: undefined,
      taskOptions: [] as IOption[],
      dayEvents: [] as TimelineEvent[],
      selectedTimeRange: { start: '', end: '' },
      values: {} as graphModels.IValues,
      detailModal: false,
      enableFixAccordion: true,
      searchText: '',
    };
  },
  methods: {
    getParentID(v: any) {
      return v.departmentID;
    },
    getParentText(v: any) {
      return v.name;
    },
    getChildID(v: any) {
      return v.userID;
    },
    getChildText(v: any) {
      return `${v.sei}${v.mei}`;
    },
    getChildTextSearch(v: any) {
      return `${v.sei}${v.mei}${v.seiKana}${v.meiKana}`;
    },
    SELECTED_ID(): string {
      return this.selectedDepartmentID > -1 ? `p${this.selectedDepartmentID}` : `c${this.selectedUserID}`;
    },
    inputSearchText(text: string) {
      this.searchText = text;
    },
    onClickDepartment(department: models.IDepartmentInfo) {
      this.isDefault = false;
      this.selectedDepartmentID = department.departmentID;
      this.selectedUserID = -1;
      this.selectDepartment = department;

      const dep = this.departments.find(v => v.departmentID === department.departmentID);
      if (dep) {
        dep.isClosed = !dep.isClosed;
      }
    },
    async onClickUser(user: models.IUser) {
      this.isDefault = false;
      this.selectedDepartmentID = -1;
      this.selectedUserID = user.userID;
      this.selectUser = user;

      saveSideBarInfo(this.sideBarInfo);
      const routeDate = this.$route.query.date;
      const date = typeof routeDate === 'string' ? routeDate : formatYmd(new Date());
      routerPush(this.$router, {
        name: this.$route.name!,
        query: {
          user_id: String(user.userID),
          date,
        },
      });
    },
    onClickHeader() {
      const formattedMonth = formatYm(this.selectCalenderDate);
      routerPush(this.$router, {
        name: 'ManagementMonthly',
        query: {
          user_id: String(this.selectedUserID),
          month: formattedMonth,
        },
        params: {
          searchText: String(this.searchText),
        },
      });
    },
    setDate(d: Date) {
      this.selectedTimeRange = undefined;
      const ymd = formatYmd(d);
      routerPush(this.$router, {
        name: this.$route.name!,
        query: {
          user_id: String(this.selectedUserID),
          date: ymd,
        },
      });
    },
    showDetail(values: graphModels.IValues) {
      this.values = values;
      this.detailModal = true;
    },
    async applyRouteQuery() {
      const { date, user_id } = this.$route.query;

      const { baseDate, shouldReplace: initialShouldReplace } = resolveBaseDate(date);
      let shouldReplace = initialShouldReplace;
      if (String(user_id) !== String(this.selectedUserID)) {
        shouldReplace = true;
      }

      const periodStart = formatYmd(baseDate);

      this.date = baseDate;
      this.selectCalenderDate = baseDate;

      const laborEvents = (await fetchDailyLaborEvents(this.selectedUserID, baseDate)).map(ev =>
        mapLaborEventToTimeline(ev),
      );

      const customHolidayEvents = await fetchCustomHolidayEvents(periodStart);

      this.selectedTimeRange = {
        start: laborEvents[0] ? laborEvents[0].start : undefined,
        end: laborEvents[0] ? laborEvents[0].end : undefined,
      };

      this.dayEvents = [...laborEvents, ...customHolidayEvents];

      if (shouldReplace) {
        this.$router.replace({
          name: this.$route.name!,
          query: {
            user_id: String(this.selectedUserID),
            date: periodStart,
          },
        });
      }
    },

    findTaskTitle(taskId: number | undefined): string {
      if (taskId === undefined) {
        return '';
      }
      const hit = this.taskOptions.find(t => t.value === taskId);
      return hit ? hit.text : '';
    },
    onClickEvent(range: any) {
      this.selectedTimeRange = range;
    },
  },
  async mounted() {
    this.$emit('pushPath', this.$route.path);
    const query = this.$route.query;
    const res = await api.get<models.VUsers>('users');
    if (!res.result) {
      return;
    }
    const workCategories = await api.get<IWorkCategoryUser[]>('workmanage/work_category_by_user_id');
    this.taskOptions = workCategories.data.map(c => ({
      id: c.id,
      value: c.id,
      text: c.name,
    }));

    // -------------------------
    // データ初期化
    // -------------------------
    const { searchText } = this.$route.params;
    this.searchText = searchText || '';

    this.usersList = res.data.users;
    this.departments = GetUsingDepartmentsList(this.usersList, res.data.departments);

    const sideBarInfo = loadValidSideBarInfo(this.usersList, this.departments);
    this.departments = sideBarInfo.departments;
    this.selectedDepartmentID = sideBarInfo.selectedDepartmentID;
    this.selectedUserID = sideBarInfo.selectedUserID;

    if (this.selectedUserID !== -1) {
      this.selectUser = this.usersList.find(v => v.userID === this.selectedUserID);
      // REMOLABO-1228 環境ごとの遷移先変更の際にクエリの上書きを避けるため、pathが違えば何もしない
      if (this.$route.path.indexOf('/labor/management/daily') === 0) {
        await this.applyRouteQuery();
      }
    }

    // -------------------------
    // SP用サイドバー初期表示
    // -------------------------
    if (query && query.md) {
      this.isDefault = true;
    }

    this.$nextTick(() => {
      this.enableFixAccordion = false;
    });
  },
  computed: {
    sideBarInfo(): SideBarInfo {
      const sideBarInfo = {
        departments: this.departments,
        selectedDepartmentID: this.selectedDepartmentID,
        selectedUserID: this.selectedUserID,
      };
      return sideBarInfo;
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.applyRouteQuery();
      },
    },
    'departments': {
      deep: true,
      handler() {
        saveSideBarInfo(this.sideBarInfo);
      },
    },
  },
});
